var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAtomsIconFilledCompass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.033 2c5.523.017 9.985 4.51 9.967 10.033-.018 5.523-4.51 9.985-10.033 9.967C6.444 21.982 1.982 17.49 2 11.967 2.018 6.444 6.51 1.981 12.033 2zm6.404 3.758s.206-.401-.207-.19l-7.95 4.087s-.412.213-.619.614l-4.098 7.973s-.206.402.207.19l7.95-4.087s.412-.213.619-.615zm-6.432 4.575a1.667 1.667 0 1 1-.01 3.333 1.667 1.667 0 0 1 .01-3.333z",
    fill: "#F60",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtomsIconFilledCompass);
export default __webpack_public_path__ + "static/media/atoms-icon-filled-compass.214aa2127668774c0a242d2617a892ef.svg";
export { ForwardRef as ReactComponent };